export class TagsConfigValidator {
    validate(data) {
        const name = data.name;
        const url = data.url;
        const utmSource = data.utmSource;
        const validName = this.validateString(name);
        const validURL = this.validateString(url);
        const validUTMSource = this.validateString(utmSource);
        const valid = validName && validURL && validUTMSource;
        return valid;
    }

    validateString(string) {
        return typeof string === 'string' && string.trim().length !== 0;
    }
}
